<template>
    <div>
        <loading-component :value="loading > 0"></loading-component>
        <v-card>
            <v-form ref="car_info_form">
                <v-container :fluid="true" style="padding:0">
                    <v-layout row wrap>
                        <v-flex xs4>
                            <div class="px-3">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-select
                                                label="Car Brand"
                                                v-model="car.car_brand_id"
                                                autocomplete
                                                cache-items
                                                chips
                                                item-text="name"
                                                item-value="id"
                                                :items="brands"
                                                :rules="numberRules"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs12>
                                        <v-select
                                                label="Car Model"
                                                v-model="car.brand_model_id"
                                                autocomplete
                                                cache-items
                                                chips
                                                item-text="name"
                                                item-value="id"
                                                :items="models"
                                                :rules="numberRules"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs12>
                                        <v-select
                                                label="Car Color"
                                                v-model="car.color_id"
                                                autocomplete
                                                cache-items
                                                chips
                                                item-text="name"
                                                item-value="id"
                                                :items="colors"
                                                :rules="numberRules"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs12>
                                        <v-text-field label="Number" v-model="car.number"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs12>
                                        <v-menu
                                                style="z-index:1000000000 !important;"
                                                v-model="date_menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="car.insurance_expired_date"
                                                        label="Insurance expired date"
                                                        readonly
                                                        append-icon="event"
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="car.insurance_expired_date"
                                                           @input="date_menu = false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs12>
                                        <v-text-field label="Car Manufacture Year"
                                                      v-model="car.car_manufacture_year"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs12>
                                        <v-select :items="api.CONSTANTS.STATES" v-model="car.state" label="State"/>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs12>
                                        <v-select
                                                label="Select car services"
                                                multiple
                                                v-model="selected_services"
                                                autocomplete
                                                chips
                                                cache-items
                                                :search-input.sync="searchService"
                                                item-text="name"
                                                item-value="id"
                                                :loading="loadingService"
                                                :items="items"
                                                :rules="arrayRules"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="mt-4" row>
                                    <v-flex xs5>
                                        <b>Created At</b>
                                    </v-flex>
                                    <v-flex xs7>
                                        {{ $companyTime(car.created_at, 'DD MMM YYYY') }}
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                        <v-flex xs8>
                            <v-layout row wrap>
                                <v-flex xs6 v-for="(imageInput,i) of imageInputs" :key="imageInput">
                                    <div class="px-3">
                                        <v-img :src="files[imageInput].url ? files[imageInput].url : api.GET_IMAGE(car[imageInput])"
                                               width="60%"
                                               v-if="files[imageInput].url || car[imageInput]"/>
                                        <input type="file" style="display: none" ref="imageInput"
                                               accept="image/*,application/pdf" @change="onFilePicked(i)">
                                        <v-text-field :label="'Upload ' +imageInput"
                                                      @click='$refs.imageInput[i].click()'
                                                      v-model='files[imageInput].name' :rules="fileRules"
                                                      append-icon='attach_file'
                                                      readonly/>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                    </v-layout>
                </v-container>
            </v-form>
        </v-card>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";

    const imageInputs = ['insurance_document_front', 'insurance_document_back', 'car_document_front', 'car_document_back'];

    export default {
        name: "CarInfo",
        components: {LoadingComponent},
        data() {
            return {
                date_menu: false,
                year_menu: false,
                loading: 0,
                files: Object.assign(...imageInputs.map(imageInput => ({
                    [imageInput]: {}
                }))),
                car: {},
                original_car: {},
                fileRules: [
                    v => !!v || 'File is required',
                ],
                numberRules: [
                    v => !!v || 'Required field',
                    v => /^[0-9]*$/.test(v) || 'invalid value'
                ],
                arrayRules: [
                    v => Array.isArray(v) && v.length >= 0 || 'Required'
                ],
                selected_services: [],
                loadingService: false,
                searchService: '',
                items: [],
                brands: [],
                models: [],
                colors: []
            }
        },
        mounted() {
            this.loading += 2;
            this.axios.get('car_brand?perPage=100').then(res => this.brands = res.data.data.data).catch(err => console.log(err.messages)).finally(() => this.loading--);
            this.axios.get('color?perPage=100').then(res => this.colors = res.data.data.data).catch(err => console.log(err.messages)).finally(() => this.loading--);
        },
        computed: {
            car_brand_id() {
                return this.car.car_brand_id;
            },
            imageInputs() {
                return imageInputs
            }
        },
        watch: {
            car_brand_id(val) {
                if (!val) return;
                this.loading++;
                this.axios.get(`car_brand/${val}/models?perPage=100`)
                    .then(res => {
                        this.models = res.data.data.data;
                        let index = this.models.findIndex((elem) => elem.id === this.car.brand_model_id);
                        if (index >= 0) {
                            this.car.brand_model_id = this.models[index].id;
                        } else {
                            this.car.brand_model_id = null;
                        }

                    }).catch(err => console.log(err.message)).finally(() => this.loading--);
            },
            selected_services: {
                handler(val) {
                    this.car.services = JSON.parse(JSON.stringify(val));
                },
                deep: true
            },
            searchService(val) {
                this.loadingService = true;
                this.axios.get(`service?search=${val}`)
                    .then(res => {
                        if (res.data.data.data.length) {
                            this.items = res.data.data.data;
                        }
                    }).catch(err => console.log(err.response)).finally(() => this.loadingService = false)
            }
        },
        methods: {
            reset() {
                this.car = {};
                this.original_car = {};
                this.files = Object.assign(...imageInputs.map(imageInput => ({
                    [imageInput]: {}
                })));
                this.$refs.car_info_form.reset();
            },
            update(id, is_car = false) {
                this.reset();
                this.loading++;
                let url = '';
                if (is_car) {
                    url = `car/${id}`;
                } else {
                    url = `captain/${id}/cars?active`;
                }
                this.axios.get(url)
                    .then(res => {
                        this.car = res.data.data;
                        this.items = res.data.data.attached_services;
                        this.items.forEach(elem => this.selected_services.push(elem.id));
                        this.original_car = JSON.parse(JSON.stringify(this.car));
                        for (let key of this.imageInputs)
                            this.files[key] = {name: key};
                    }).catch(err => console.log(err.message))
                    .finally(() => this.loading--);
            },
            async submit(captain_id = null) {
                const formData = new FormData();

                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };

                if (!this.$refs.car_info_form.validate()) {
                    this.$emit('done');
                    return;
                }

                if (!_.isEqual(this.original_car, this.car)) {
                    Object.keys(this.car).forEach(elem => {
                        if (elem !== 'approved' && imageInputs.indexOf(elem) === -1 && this.car[elem] !== null) {
                            formData.append(elem, this.car[elem]);
                        }
                    });
                }
                for (let imageInput of this.imageInputs)
                    if (this.files[imageInput].changed)
                        formData.append(imageInput, this.files[imageInput].file);

                if (!this.car.approved) {
                    formData.append('approved', 1);
                }

                if (this.car.services) {
                    for (let i = 0; i < this.car.services.length; i++) {
                        formData.append('services[]', this.car.services[i]);
                    }
                }
                let path = 'car';
                if (captain_id) {
                    this.car.captain_id = captain_id;
                } else {
                    formData.append('_method', 'PUT');
                    path += `/${this.car.id}`;
                }
                await this.axios.post(path, formData, config)
                    .then((res) => this.$emit('next_step', res.data.data))
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    }).finally(() => this.$emit('done'));
                this.loading = false;
            },
            onFilePicked(idx) {
                const files = this.$refs.imageInput[idx].files;
                const type = this.imageInputs[idx];
                if (files[0] !== undefined) {
                    this.files[type].changed = true;
                    this.files[type].name = files[0].name;
                    if (this.files[type].name.lastIndexOf('.') <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.$set(this.files[type], 'url', fr.result);
                        this.files[type].file = files[0];
                    })
                } else {
                    this.files[type] = {};
                }
            },
        }
    }
</script>

<style scoped>

</style>